import React, { ReactNode, useState } from "react";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import IconButton from "@mui/material/IconButton";
import { Grid } from "@mui/material";
import { ContactFormAccordianContainer } from "./ContactFormAccordianContainer";
import CollapsedInnerContainer from "./CollapsedInnerContainer";
import generalDetailsIcon from "../../../assets/images/main/generalDetailsIcon.svg";
import addressDetailsIcon from "../../../assets/images/main/addressDetailsIcon.svg";

interface FormDetails {
  generalDetailsForm: ReactNode;
  addressDetailsForm: ReactNode;
  secondCollapseTitle?: string;
  secondCollapseIcon?: string | undefined;
}
const ContactFormAccordian: React.FC<FormDetails> = ({
  generalDetailsForm,
  addressDetailsForm,
  secondCollapseTitle = "Address Details",
  secondCollapseIcon = addressDetailsIcon,
}) => {
  const [generalDetailsOpen, setGeneralDetailsOpen] = useState(true);
  const [addressDetailsOpen, setAddressDetailsOpen] = useState(false);
  const [generalDetailsError, setGeneralDetailsError] = useState(false);
  const [addressDetailsError, setAddressDetailsError] = useState(false);
  const handleGeneralDetailsClick = () => {
    setGeneralDetailsOpen(!generalDetailsOpen);
    setAddressDetailsOpen(!addressDetailsOpen);
  };

  const handleAddressDetailsClick = () => {
    setGeneralDetailsOpen(!generalDetailsOpen);
    setAddressDetailsOpen(!addressDetailsOpen);
  };
  React.useEffect(() => {
    if (React.isValidElement(generalDetailsForm)) {
      const errors = generalDetailsForm.props?.errors || {};
      const hasAddressDetailsError = !!errors.addressDetails;
      const hasGeneralErrors = Object.keys(errors).some(
        (key) => key !== "addressDetails"
      );

      setAddressDetailsError(hasAddressDetailsError);
      setGeneralDetailsError(hasGeneralErrors);
    }
  }, [generalDetailsForm]);

  return (
    <ContactFormAccordianContainer>
      {/* General Details card */}
      <Card className="main-card-component">
        <div
          className="header-icon"
          style={{
            backgroundColor: generalDetailsError
              ? "red"
              : generalDetailsOpen
              ? "#00a4e5"
              : "#bcb9c8",
            cursor: "pointer",
          }}
        >
          <img src={generalDetailsIcon} alt={"General Details Icon"} />
        </div>

        <CardHeader
          sx={{
            color: generalDetailsError
              ? "red"
              : generalDetailsOpen
              ? "#00a4e5"
              : "#bcb9c8",
            cursor: "pointer",
          }}
          title="General Details"
          onClick={handleGeneralDetailsClick}
          className="header-name"
          action={
            <IconButton
              onClick={handleGeneralDetailsClick}
              aria-label="expand"
              size="small"
              className="collapse-icon"
            >
              {generalDetailsOpen ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          }
        ></CardHeader>

        <CollapsedInnerContainer>
          <Collapse in={generalDetailsOpen} timeout="auto" unmountOnExit>
            <CardContent className="card-content">
              <div className="lineCollapse"></div>
              <Grid container item lg={12} spacing={2}>
                <Grid className="accordian-details" item lg="auto">
                  {generalDetailsForm}
                </Grid>
              </Grid>
            </CardContent>
          </Collapse>
        </CollapsedInnerContainer>
      </Card>
      {/* End */}

      {/* Address Details card */}
      <Card
        className="main-card-component"
        sx={{ paddingTop: "20px", paddingBottom: "10px" }}
      >
        <div
          className="header-icon"
          style={{
            top: "33px",
            backgroundColor: addressDetailsError
              ? "red"
              : addressDetailsOpen
              ? "#00a4e5"
              : "#bcb9c8",
            cursor: "pointer",
          }}
        >
          <img src={secondCollapseIcon} alt={"icon"} />
        </div>

        <CardHeader
          sx={{
            color: addressDetailsError
              ? "red"
              : addressDetailsOpen
              ? "#00a4e5"
              : "#bcb9c8",
            cursor: "pointer",
          }}
          title={secondCollapseTitle}
          className="header-name"
          onClick={handleAddressDetailsClick}
          action={
            <IconButton
              onClick={handleAddressDetailsClick}
              aria-label="expand"
              size="small"
              className="collapse-icon"
            >
              {addressDetailsOpen ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          }
        ></CardHeader>

        <CollapsedInnerContainer className={""} subClassName={""}>
          <Collapse in={addressDetailsOpen} timeout="auto" unmountOnExit>
            <CardContent>
              <Grid container item lg={12} spacing={2}>
                <Grid className="accordian-details" item lg="auto">
                  {addressDetailsForm}
                </Grid>
              </Grid>
            </CardContent>
          </Collapse>
        </CollapsedInnerContainer>
      </Card>
      {/* End */}
    </ContactFormAccordianContainer>
  );
};

export default ContactFormAccordian;
